import { useEffect } from 'react';
import { ClientRole } from '../types';
import { fetchSession } from '../services/sessionApi';
import { connectSessionSocket } from '../services/sessionSocket';
import { useSessionStore } from '../store/sessionStore';

/** Подтягивает сессию по HTTP и держит её через WebSocket. */
export function useSessionSync(role: ClientRole): void {
  const applySession = useSessionStore((state) => state.applySession);

  useEffect(() => {
    let cancelled = false;

    fetchSession()
      .then((session) => {
        if (!cancelled) applySession(session);
      })
      .catch((error) => {
        console.error('Не удалось загрузить сессию:', error);
      });

    const disconnect = connectSessionSocket(role, (session) => {
      if (!cancelled) applySession(session);
    });

    return () => {
      cancelled = true;
      disconnect();
    };
  }, [role, applySession]);
}
